import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { COLLAPSE } from "@/components/Reveal";

export const Accordion = ({ items, testid, itemTestid, dark = true }) => {
  const [open, setOpen] = useState(0);
  const q = dark ? "text-cream" : "text-ink";
  const a = dark ? "text-mist" : "text-fern";
  const icon = dark ? "text-leaf" : "text-leafdeep";
  const line = dark ? "border-white/10" : "border-ink/10";

  return (
    <div data-testid={testid}>
      {items.map((f, i) => (
        <div key={f.q} className={`border-b ${line}`}>
          <button
            data-testid={`${itemTestid}-${i}`}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-6 py-6 text-left"
          >
            <span className={`font-serif text-lg ${q}`}>{f.q}</span>
            <Plus className={`h-5 w-5 shrink-0 ${icon} transition-transform duration-300 ${open === i ? "rotate-45" : ""}`} />
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.div {...COLLAPSE} className="overflow-hidden">
                <p className={`max-w-2xl pb-6 font-sans text-sm leading-relaxed ${a} sm:text-base`}>{f.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
};
